export default __webpack_public_path__ + "static/media/asad-irshad.37f4786e.png";